<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T15:54:30+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe
@Last modified by:   tom
@Last modified time: 2018-02-05T17:38:58+01:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved

Enables a special bullet list item, use it like this:
  <ul>
    <lii horizontal>One check</lii>  // first icon hidden in this list
    <lii icon="check" horizontal>Two check</lii>
    <lii icon="check" horizontal color="info">Two check</lii>
  </ul>

Optional parameter:
  horizontal: Boolean
  box: Boolean to set button outline
   icon='' to hide the icon

-->

<template>
  <!-- verical align the icon if there is button -->
  <li v-if="label"
      class="lii"
      :class="[
        {ishor: horizontal},
        {'d-flex align-items-center h-100': button},
        {showpointer: showToolTip}]"
      :style="'margin-left:'+ iconMarginLeft + 'px;'"
  >
    <icon v-if="icon"
          class=""
          :name="icon"
          :scale="iconScale"
          :style="'top:'+ iconMarginTop +'px; width: ' + iconScale * 20 + 'px;'"
          :class="[{isvert : !horizontal}, 'text-'+color]"
    />
    <span v-b-tooltip.hover
          :class="buttonClass"
          :title="tooltip"
          v-html="label"
    >
      <slot />
    </span>
  </li>
</template>

<script>
export default {
  name: 'Lii',
  props: {
    icon: {
      type: String, // fontawesome key, "check", "user-o",...
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    button: {
      type: Boolean,
      default: true
    },
    outline: {
      type: Boolean,
      default: false
    },
    size: {
      type: String, // Bootstrap button size: "sm" or "lg"
      default: ''
    },
    color: {
      type: String,
      default: 'secondary'
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  computed: {
    showToolTip: function () {
      return this.tooltip !== ''
    },
    buttonClass: function () {
      // creating Bootstrap button if we need labels to be shown in buttons
      let butt = ''
      if (this.button) {
        butt = this.outline ? 'btn btn-outline-' + this.color : 'btn btn-' + this.color
        butt = butt + (this.size ? ' btn-' + this.size : '')
      } else {
        //
      }
      return butt
    },
    iconScale: function () {
      // setting the scale for the icon based on Bootstrap sm|lg scaling
      let scale = 2
      scale = this.size === 'sm' ? '1' : scale
      scale = this.size === 'lg' ? '3' : scale
      return scale
    },
    iconMarginTop: function () {
      // aiming to vertical centre the icon and the li label
      if (!this.button) {
        if (this.horizontal) {
          return (6 * this.iconScale) - 3
        } else {
          return (6 - (2 * this.iconScale))
        }
      }
      // button is centred by inline classes
      return 0
    },
    iconMarginLeft: function () {
      // aiming to position the icon and the li label
      if (this.horizontal) {
        return 10
      } else {
        return 2 + (20 * this.iconScale)
      }
    }
  }
}
</script>

<style lang="scss">
  // general icon styling as seems best place (although should be part of <icon>)
  .fa-icon {
    width: auto;
    // You would have to include the following two lines to make this work in Safari
    max-width: 100%;
    max-height: 100%;
    &.float-left {
      position: relative;
      margin-right: 5px;
    }
  }

  // li styling
  .lii {
    margin-right: 0 !important;
    list-style-type: none;
    text-align: left;
    margin-bottom: 0.3em;
    // prevent the li elements to split over multiple lines
    // so they should always fit on one line
    &.ishor {
      display: inline-block;
      text-align: center;
    }
    &.showpointer {
      cursor: pointer !important;
    }
    .btn {
      margin-bottom: 2px;
      padding: 2px 10px;
      cursor: default !important;
    }
    i {
      font-size: 0.6em;
    }
    .fa-icon {
      margin-left: 6px;
      position: relative;
      &.isvert {
        margin-left: -1.3em;
        margin-right: .2em;
        float: left;
        line-height: 1.8em;
        height: 0.9em; // or any other relative font sizes
      }
    }

  }
  .btn-outline-info {
    background-color: #fff;
  }
  // inlinemarks no bullets on mobile screen
  // @media (max-width: 768px) {
  //   .lii {
  //     display: block;
  //     margin: 3px 0 0 0;
  //     .icon {
  //       display: none ;
  //     }
  //   }
  // }
</style>
